<template>
  <div class="engagement-wrapper print-bg" :class="{'engagement-wrapper_isef' : $isIsef, 'engagement-wrapper_auditorium': this.isAuditoriumStory}">
    <div class="engagement-container"
         :class="{ 'is-fixed': makeFixed, 'fix-to-bottom': !isStory, 'fix-to-top': isStory,
         'has-publish-toolbar': isAdmin, 'is-invisible': makeInvisible }" ref="engagementContainer">
      <div v-if="isFinalistBooth && $isIsef && awards.length > 0" class="awards-container">
        <div v-for="(award) in awards" class="award" :data-balloon="award.name" data-balloon-pos="right" :key="award.id">
          <img class="img-awards" :class="{'hide-award' : award.id === 71}" :src="award.image" :alt="award.name"/>
        </div>
      </div>
      <div class="engagement">
        <div class="dropdown-wrapper">
          <div v-bind="followTooltipLike">
            <i @click="loginAndLike" :class="{fa: hasLiked, fal: !hasLiked}" tabindex="0" aria-label="Like this project" @keypress.enter.space="loginAndLike" class="fa-thumbs-up"></i>
            <div @mouseenter="showLikes" @mouseleave="hideLikes">
              <div v-if="dropdowns.likes.show && !isTouch && numLikes > 0">
                <drop-down :isHeader="true" :users="dropdowns.likes.users" :loading="dropdowns.likes.loading" @fetch="fetchLikedBy" @close="hideLikes"></drop-down>
              </div>
              <span class="has-text-weight-light">{{numLikes}}</span>
            </div>
          </div>
        </div>

        <div class="meta-views">
          <div v-bind="engagementTooltip">
            <i class="fal fa-fingerprint" tabindex="0" aria-label="Project engagement count"></i>
            <span class="has-text-weight-light">{{ numEngagement }}</span>
            <span v-if="engagementIsOpen" data-balloon-visible :data-balloon="tooltipText" :data-balloon-pos="tooltipPosition" data-balloon-length="medium" class="mobile-tooltip"></span>
          </div>
        </div>

        <div class="dropdown-wrapper">
          <div v-bind="followTooltipSubscription">
            <i :class="{fas: hasSubscribed, 'bookmarked': hasSubscribed, fal: !hasSubscribed}" class="fa-bookmark" @click="likeAndSubscribe" @keypress.enter.space="likeAndSubscribe" tabindex="0" aria-label="Save and bookmark this project"></i>
            <div @mouseenter="showSubscribers" @mouseleave="hideSubscribers">
              <div v-if="dropdowns.subscribers.show && !isTouch && numSubscribers > 0">
                <drop-down :isHeader="true" :title="bookmarkTitle" :users="dropdowns.subscribers.users" :loading="dropdowns.subscribers.loading" @fetch="fetchSubscribers" @close="hideSubscribers"></drop-down>
              </div>
              <span class="dropdown-count has-text-weight-light">{{numSubscribers}}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="milieu float-action-button" v-if="!project.isPrivate && showShareSocial">
        <div :class="{'socialContainerAnimated' : shareMobile, 'socialContainerBottom' : (hasScrolledSocialContainer && !doesIncludePrint), 'bottomPrint' : (hasScrolledSocialContainer && doesIncludePrint), 'dropdownOpened' : !shareMobile }" class="socialContainer" ref="socialContainer" v-click-outside="clickOutside">
          <span class="is-size-7 has-text-weight-light is-hidden-mobile milieu-text is-uppercase shareDesktop">{{ $t("projectPage.share") }}</span>
          <social-sharing v-bind="shareToTwitter" :url="getShareURL('twitter')" @open="track('twitter')"
            :title="project.title"
            :description="project.description"
            :quote="project.title"
            :hashtags="hashTag"
            v-cloak inline-template
            :class="{'socialicons' : shareMobile}"
            class="gtm-proj-twitter gtm-twitter-share cursor-pointer socialshare twitterAnimation"
            tabindex="-1">
            <network network="twitter" class="milieu-icon twitter gtm-twitter-share">
              <i class="fab fa-twitter"></i>
            </network>
          </social-sharing>
          <social-sharing v-bind="shareToFacebook" :class="{'socialicons' : shareMobile}" :url="getShareURL('facebook')" @open="track('facebook')"
            :title="project.title"
            :description="project.description"
            :quote="project.title"
            :hashtags="hashTag"
            v-cloak inline-template
            class="gtm-proj-facebook gtm-facebook-share cursor-pointer socialshare facebookAnimation"
            tabindex="-1">
            <network network="facebook" class="milieu-icon facebook gtm-facebook-share">
              <i class="fab fa-facebook-f"></i>
            </network>
          </social-sharing>
          <span :class="{'socialicons' : shareMobile}" class="milieu-icon pinterest gtm-proj-pinterest gtm-pinterest-share cursor-pointer socialshare pinterestAnimation" v-bind="shareToPinterest">
            <a data-pin-do="buttonBookmark" data-pin-round="true" tabindex="0" target="_blank" :href="pinterestUrl" >
              <div class="pinterestContainer">
                <i class="fab fa-pinterest" id="pinterest-red"></i>
              </div>
            </a>
          </span>
          <social-sharing :url="getShareURL('linkedin')" @open="track('linkedin')" v-bind="shareToLinkedin"
            :title="project.title"
            :description="project.description"
            :quote="project.title"
            :hashtags="hashTag"
            v-cloak inline-template
            :class="{'socialicons' : shareMobile}"
            class="gtm-proj-linkedin gtm-linkedin-share cursor-pointer socialshare linkedinAnimation"
            tabindex="-1">
            <network network="linkedin" class="milieu-icon linkedin gtm-linkedin-share">
              <i class="fab fa-linkedin"></i>
            </network>
          </social-sharing>
          <span>
          <a v-bind:href="'https://classroom.google.com/share?url=' + getShareURL('google')" tabindex="0" target="_blank" v-bind="shareToGoogle" :class="{'socialicons' : shareMobile}" class="milieu-icon google socialshare classroomAnimation"> <img style="width: 30px;" src="/static/icons/googleclass-green.png"></a>
          </span>
          <span>
          <a v-bind:href="'https://www.reddit.com/submit?url=' + getShareURL('reddit')" tabindex="0" target="_blank" v-bind="shareToReddit" :class="{'socialicons' : shareMobile}" class="milieu-icon google socialshare classroomAnimation"><i class="fab fa-reddit" id="reddit-orange"></i></a>
          </span>
          <a :class="{'socialicons' : shareMobile}" class="milieu-icon copy socialshare copyAnimation" tabindex="0" @keypress.enter.space="copyURL()" @click="copyURL()" v-bind="copyLink">
            <i class="fal fa-link"></i>
          </a>
          <input type="hidden" id="link" :value="getShareURL('copyUrl')"  readonly>
          <div v-if="doesIncludePrint">
            <a v-bind="printTooltip" :class="{'socialicons' : shareMobile}" class="milieu-icon print printAnimation socialshare" tabindex="0" @keypress.enter.space="printPage()" @click="printPage()">
              <i class="fal fa-print"></i>
            </a>
          </div>
        </div>
        <button ref="shareButton" @click="clickShare" class="main-button"><img src="/static/icons/sharesocial.png"></button>
      </div>
    </div>
    <fade-message :message="copySuccess" :error="copyError" @clearMessage="copySuccess = ''" @clearError="copyError = ''"></fade-message>
    <script type="application/javascript" src="https://apis.google.com/js/platform.js"></script>
  </div>
</template>

<script>
import SocialSharing from 'vue-social-sharing'
import throttle from 'lodash/throttle'
import moment from 'moment'
import userAgent from '@/libs/user-agent'
import socket from '@/libs/socket'
import breakpoints from '@/libs/breakpoints'
import subscribe from '@/mixins/subscribe'
import auth from '@/mixins/auth'
import DropDown from '@/components/Controls/MetaCountsDropdown'
import dropDownMixin from '@/components/Controls/MetaCountsDropdown/mixin'
import i18n from '@/i18n'
import state from '../state'
import componentState from '@/mixins/component-state'

import ClickOutside from 'vue-click-outside'
import FadeMessage from '@/components/Controls/FadeMessage'

const tabletBreakpoint = 1023
const navbarHeight = 53

export default {
  components: {
    SocialSharing,
    DropDown,
    FadeMessage
  },
  props: ['project', 'post', 'projectHeight', 'tab', 'awards'],
  mixins: [auth, dropDownMixin, subscribe, componentState],
  data: function () {
    return {
      fetchLimit: 10,
      scrollTop: 0,
      scrollBottom: 0,
      dropdowns: {
        likes: dropDownMixin.initDropdown(),
        subscribers: dropDownMixin.initDropdown()
      },
      engagementIsOpen: false,
      copySuccess: '',
      copyError: '',
      isMounted: false,
      shareMobile: false
    }
  },
  created: function () {
    this.attachScrollListener()
  },
  destroyed: function () {
    this.detachScrollListener()
  },
  computed: {
    isIE11: function () {
      return userAgent.isIE11()
    },
    isMobileOrTablet: function () {
      return screen.width < tabletBreakpoint
    },
    isAuditoriumStory: function () {
      return this.$route.path.includes('auditoriumStory')
    },
    hasScrolledToSocial: function () {
      return this.scrollTop > this.scrollEngagement + navbarHeight
    },
    hasScrolledToFooter: function () {
      return this.scrollBottom > this.projectHeight + navbarHeight / 4
    },
    hasScrolledSocialContainer: function () {
      if (this.$isEngCom) {
        return this.scrollTop > ((this.scrollEngagement - navbarHeight) - this.scrollShare)
      } else {
        return this.scrollTop > ((this.scrollEngagement - navbarHeight) - this.scrollShare) && this.scrollTop < (this.scrollEngagement + navbarHeight)
      }
    },
    makeFixed: function () {
      return this.isMobileOrTablet ? this.hasScrolledToSocial : false
    },
    makeInvisible: function () {
      return this.isMobileOrTablet ? this.hasScrolledToFooter && this.hasScrolledToSocial : false
    },
    referralCode: function () {
      return this.$store.getters.referralCode
    },
    hashTag: function () {
      if (this.$isEngCom) {
        return 'engineeringcom'
      } else {
        return 'makeprojects'
      }
    },
    isStory: function () {
      return this.$route.name === 'viewStory'
    },
    isProject: function () {
      return this.$route.name === 'viewProject'
    },
    bookmarkTitle: function () {
      return this.isStory ? 'Bookmarked by' : 'Followers'
    },
    projectMetadata: function () {
      return this.project && this.project.metadata ? this.project.metadata : {}
    },
    postMetadata: function () {
      return this.post && this.post.metadata ? this.post.metadata : {}
    },
    source: function () {
      return this.isStory ? 'post' : 'project'
    },
    numLikes: function () {
      return this.loading ? '-' : this[`${this.source}Metadata`].likes || 0
    },
    numSubscribers: function () {
      return this.loading ? '-' : this.projectMetadata.subscribers || 0
    },
    numTeamMembers: function () {
      return this.loading ? '-' : this.projectMetadata.members || 0
    },
    numComments: function () {
      return this.loading ? '-' : this.projectMetadata.comments || 0
    },
    numEngagement: function () {
      return this.loading ? '-' : this.projectMetadata.engagement || 0
    },
    numPosts: function () {
      return this.loading ? '-' : this.projectMetadata.posts || 0
    },
    hasLiked: function () {
      return this.isLoggedIn && this[this.source] ? this.$store.getters[`liked${this.capitalize(this.source)}`](this[this.source].id, this.currentUser.userName) : false
    },
    isTouch: function () {
      return userAgent.isIOS() || userAgent.isAndroid()
    },
    isApp: function () {
      return userAgent.isApp()
    },
    isMobileAndApp: function () {
      return userAgent.isApp() || userAgent.isIOS() || userAgent.isAndroid()
    },
    isMobile: function () {
      return breakpoints.isMobile()
    },
    isTablet: function () {
      return breakpoints.isTablet()
    },
    isTabletAndUp: function () {
      return breakpoints.isTabletAndUp()
    },
    isMobileStories: function () {
      return this.isMobile && this.$isStories
    },
    followTooltipSubscription: function () {
      const tooltip = {}
      if (!this.isMobile) {
        if (!this.hasSubscribed) {
          tooltip['data-balloon'] = i18n.t('projectPage.clickToBookmark')
        } else {
          tooltip['data-balloon'] = i18n.t('projectPage.clickToRemoveBookmark')
        }
        tooltip['data-balloon-pos'] = this.numSubscribers > 0 ? 'right' : 'down'
      }
      if (this.isMobile || this.isTablet) {
        tooltip['data-balloon-pos'] = 'down'
      }
      return tooltip
    },
    followTooltipLike: function () {
      const tooltip = {}
      if (!this.isMobile) {
        if (!this.hasLiked) {
          tooltip['data-balloon'] = i18n.t('projectPage.clickToLike')
        } else {
          tooltip['data-balloon'] = i18n.t('projectPage.clickToUnlike')
        }
        tooltip['data-balloon-pos'] = this.numLikes > 0 ? 'right' : 'down'
      }
      if (this.isMobile || this.isTablet) {
        tooltip['data-balloon-pos'] = 'down'
      }
      return tooltip
    },
    shareToTwitter: function () {
      if (this.isTabletAndUp) {
        const tooltip = {}
        tooltip['data-balloon'] = i18n.t('projectPage.shareToTwitter')
        tooltip['data-balloon-pos'] = 'right'
        return tooltip
      }
    },
    shareToFacebook: function () {
      if (this.isTabletAndUp) {
        const tooltip = {}
        tooltip['data-balloon'] = i18n.t('projectPage.shareToFacebook')
        tooltip['data-balloon-pos'] = 'right'
        return tooltip
      }
    },
    printTooltip: function () {
      if (this.isTabletAndUp) {
        const tooltip = {}
        tooltip['data-balloon'] = 'Click to print'
        tooltip['data-balloon-pos'] = 'right'
        return tooltip
      }
    },
    shareToPinterest: function () {
      if (this.isTabletAndUp) {
        const tooltip = {}
        tooltip['data-balloon'] = i18n.t('projectPage.shareToPinterest')
        tooltip['data-balloon-pos'] = 'right'
        return tooltip
      }
    },
    shareToLinkedin: function () {
      if (this.isTabletAndUp) {
        const tooltip = {}
        tooltip['data-balloon'] = i18n.t('projectPage.shareToLinkedin')
        tooltip['data-balloon-pos'] = 'right'
        return tooltip
      }
    },
    shareToGoogle: function () {
      if (this.isTabletAndUp) {
        const tooltip = {}
        tooltip['data-balloon'] = i18n.t('projectPage.shareToGoogle')
        tooltip['data-balloon-pos'] = 'right'
        return tooltip
      }
    },
    shareToReddit: function () {
      if (this.isTabletAndUp) {
        const tooltip = {}
        tooltip['data-balloon'] = i18n.t('projectPage.shareToReddit')
        tooltip['data-balloon-pos'] = 'right'
        return tooltip
      }
    },
    copyLink: function () {
      if (this.isTabletAndUp) {
        const tooltip = {}
        tooltip['data-balloon'] = i18n.t('projectPage.copyLink')
        tooltip['data-balloon-pos'] = 'right'
        return tooltip
      }
    },
    print: function () {
      const tooltip = {}
      tooltip['data-balloon'] = i18n.t('projectPage.print')
      tooltip['data-balloon-pos'] = 'right'
      if (this.isMobile || this.isTablet) {
        tooltip['data-balloon-pos'] = 'down-left'
        tooltip['data-balloon-length'] = 'large'
      }
      return tooltip
    },
    signupMessage: function () {
      return this.$isEngCom ? 'Sign up to like this story.' : i18n.t('projectPage.signUpToLike')
    },
    engagementTooltip: function () {
      const tooltip = {}
      tooltip['data-balloon'] = i18n.t('projectPage.engagementCount')
      tooltip['data-balloon-pos'] = 'right'
      tooltip['data-balloon-length'] = 'large'
      if (this.isMobile || this.isTablet) {
        tooltip['data-balloon-pos'] = 'down-left'
        tooltip['data-balloon-length'] = 'medium'
      }
      return tooltip
    },
    scrollEngagement: function () {
      if (this.isMounted) {
        return this.$refs.engagementContainer ? this.$refs.engagementContainer.offsetParent.offsetTop : 0
      }
      return 0
    },
    scrollShare: function () {
      if (this.isMounted) {
        return this.$refs.socialContainer ? this.$refs.socialContainer.clientHeight : 0
      }
    },
    pinterestUrl: function () {
      const url = 'https://pinterest.com/pin/create/button/'
      const projectUrl = `?url=${encodeURIComponent(this.getShareURL('pinterest'))}`
      const desc = `&description=${encodeURIComponent(this.project.description)}`
      const media = `&media=${encodeURIComponent(this.project.image)}`
      return url + projectUrl + desc + media
    },
    getParams: function () {
      return this.isStory ? this.paramsPost : this.params
    },
    paramsPost: function () {
      return { post: this.post, username: this.currentUser.userName }
    },
    isList: function () {
      return this._get(state.activeTab) === 'list'
    },
    doesIncludePrint: function () {
      return this.project.metadata.posts <= 10 && this.isList && !this.isApp
    },
    projectSelected: function () {
      return this.$store.getters.project(this.project.id) ? this.$store.getters.project(this.project.id) : {}
    },
    hasBoothView: function () {
      return this.isProject && this.project.booth && this.project.booth.ID > 0 && !(this.project.booth.TemplateID === 21744 && this.project.id !== 57305) // We need to hard code these to handle the case for Regeneron's Booth
    },
    showViewAsBoard: function () {
      return (this.$isIsef || this.$isBroadcomMasters || this.$isSts) && (window.location.href.indexOf('career-booth') > -1 || window.location.href.indexOf('college-booth') || window.location.href.indexOf('finalist-booth') || window.location.href.indexOf('expobooth'))
    },
    isFinalistBooth: function () {
      return this.$route.name === 'finalist-booth' || this.$route.path.includes('finalist-booth')
    },
    showShareSocial: function () {
      return !this.$isCnmiIwsf
    }
  },
  watch: {
    project: function () {
      this.check()
    },
    hasLiked: function () {
      this.resetDropdownUsers('likes')
    }
  },
  mounted: function () {
    this.check()
    this.isMounted = true
    // prevent click outside event with popupItem. Always add it in mounted according documentation https://github.com/vue-bulma/click-outside#readme -vueclick-outside
    this.popupItem = this.$el
  },
  methods: {
    getShareURL: function (network) {
      const utmSource = this.getUtmSource(network)
      let pageType = this.$isStories ? 'story' : 'project'
      if (pageType === 'project') {
        if (this.$route.path.includes('auditoriumStory')) {
          pageType = 'auditoriumStory'
        } else if (this.$route.path.includes('finalist-booth')) {
          pageType = 'finalist-booth'
        } else if (this.$route.path.includes('expobooth')) {
          pageType = 'expobooth'
        } else if (this.$route.path.includes('college-booth')) {
          pageType = 'college-booth'
        } else if (this.$route.path.includes('career-booth-major-sponsor')) {
          pageType = 'career-booth-major-sponsor'
        } else if (this.$route.path.includes('project/career-booth-regeneron')) {
          pageType = 'project'
        } else if (this.$route.path.includes('career-booth-regeneron')) {
          pageType = 'career-booth-regeneron'
          this.$route.params.id = 'career-booth-regeneron'
        } else if (this.$route.path.includes('career-booth-exhibitor')) {
          pageType = 'career-booth-exhibitor'
        }
      }

      let url = `${this.$webRoot}/${pageType}/${this.$route.params.id}`
      let paramValue = '?'
      if (utmSource !== '') {
        url = url + `${paramValue}utm_source=${utmSource}`
        paramValue = '&'
      }
      if (this.post) {
        url = `${url}${paramValue}postID=${this.post.id}`
        paramValue = '&'
      }
      if (this.referralCode) {
        url = `${url}${paramValue}rc=${this.referralCode}`
      }
      return url
    },
    track: function (network) {
      socket.share(network, this.project.id, 'project')
    },
    copyURL: function () {
      const copyText = document.querySelector('#link')
      copyText.setAttribute('type', 'text')
      copyText.select()
      try {
        var successful = document.execCommand('copy')
        if (successful) {
          this.copySuccess = 'Copied!'
        } else {
          this.copyError = 'Oops, unable to copy!'
        }
      } catch (err) {
        this.copyError = 'Oops, unable to copy!'
      }
      copyText.setAttribute('type', 'hidden')
      window.getSelection().removeAllRanges()
    },
    getUtmSource: function (network) {
      if (network === 'copyUrl') {
        return ''
      }
      return `${network}_share_${this.project.id}`
    },
    check: function () {
      if (!this.isLoggedIn) {
        return
      }
      this.checkLiked()
      this.checkSubscribed()
    },
    checkLiked: function () {
      if (!this.isLoggedIn) {
        return
      }
      this.$store.dispatch(`liked${this.capitalize(this.source)}`, this.getParams)
    },
    attachScrollListener: function () {
      window.addEventListener('scroll', this.checkScrollHeight)
    },
    detachScrollListener: function () {
      window.removeEventListener('scroll', this.checkScrollHeight)
    },
    checkScrollHeight: function () {
      this.scrollTop = window.pageYOffset || document.documentElement.scrollTop
      this.scrollBottom = this.scrollTop + window.innerHeight
    },
    loginAndLike: function () {
      if (!this.isLoggedIn) {
        return this.$store.dispatch('showLoginModal', { source: 'projectlike:' + this.project.id, onSuccess: this.like, signupMessage: this.signupMessage })
      }
      this.like()
    },
    like: throttle(function () {
      if (this.hasLiked) {
        this.$store.dispatch(`unlike${this.capitalize(this.source)}`, this.getParams).then(() => {
          this.resetDropdownUsers('likes')
          return this.fetch('likes', `${this.source}LikedBy`)
        })
      } else {
        this.$store.dispatch(`like${this.capitalize(this.source)}`, this.getParams).then(() => {
          this.resetDropdownUsers('likes')
          return this.fetch('likes', `${this.source}LikedBy`)
        })
      }
    }, 500, { leading: true, trailing: false }),
    showLikes: function () {
      return this.showDropdown('likes')
    },
    hideLikes: function (event) {
      return this.hideDropdown('likes', event)
    },
    showSubscribers: function () {
      return this.showDropdown('subscribers')
    },
    hideSubscribers: function (event) {
      return this.hideDropdown('subscribers', event)
    },
    toggleSubscribers: function () {
      return this.toggleDropDown('subscribers')
    },
    checkSubscribed: function () {
      this.$store.dispatch('isSubscribedToProject', this.params)
    },
    likeAndSubscribe: function () {
      if (!this.isLoggedIn) {
        return this.$store.dispatch('showLoginModal', { source: 'projectsubscribe:' + this.project.id, onSuccess: this.toggleSubscribe, signupMessage: 'To follow this project' })
      }
      this.subscribe()
    },
    subscribe: throttle(function () {
      if (this.hasSubscribed) {
        this.$store.dispatch('unsubscribeToProject', this.params).then(() => {
          this.resetDropdownUsers('subscribers')
          return this.fetch('subscribers', 'getSubscribers')
        })
      } else {
        this.$store.dispatch('subscribeToProject', this.params).then(() => {
          this.resetDropdownUsers('subscribers')
          return this.fetch('subscribers', 'getSubscribers')
        })
      }
    }, 500, { leading: true, trailing: false }),
    fetch: function (type, method) {
      const params = { id: this[this.source].id, limit: this.fetchLimit, offset: this.dropdowns[type].offset }
      return this.fetchDropdown(type, method, params)
    },
    fetchLikedBy: function () {
      return this.fetch('likes', `${this.source}LikedBy`)
    },
    fetchSubscribers: function () {
      return this.fetch('subscribers', 'getSubscribers')
    },
    formatDate: function (date) {
      return moment(date).format('MMM DD, YYYY')
    },
    capitalize: function (string) {
      return string.charAt(0).toUpperCase() + string.slice(1)
    },
    clickShare: function () {
      this.shareMobile = !this.shareMobile
    },
    printPage: function () {
      window.print()
    },
    clickOutside: function () {
      this.shareMobile = false
    },
    goToBoothLink: function () {
      if (this.project.booth.slug && this.$isIsef) {
        if (this.project.booth.id_in_url) {
          return this.$router.push(this.project.booth.slug + '/' + this.project.id)
        } else {
          return this.$router.push(this.project.booth.slug)
        }
      }
      // TODO Refactor the booth redirection
      if (this.project.booth.slug && this.$isSts) {
        if (this.project.booth.slug === 'career-booth-regeneron') {
          return this.$router.push(`/${this.project.booth.slug}`)
        }
      }

      if (this.project.booth.slug && this.project.booth.slug === 'expobooth') {
        return this.$router.push(this.project.booth.slug + '/' + this.project.id)
      } else {
        return this.$router.push('/' + this.project.booth.slug + '/' + this.projectSelected.id)
      }
    },
    goToProjectLink: function () {
      if ((this.project.booth?.slug) && this.project.id === 57305) {
        return this.$router.push('/project/' + this.project.booth.slug)
      }
      return this.$router.push('/project/' + this.projectSelected.id)
    }
  },
  directives: {
    ClickOutside
  }
}
</script>

<style lang="scss" scoped>
@import '~styles/utils.scss';
.engagement-wrapper {
  top: calc(72px + 0.5rem);
  left: calc(100vw/2 - 400px - 100px - 3rem);

  width: 100px;
  position: fixed;
  z-index: 5;

  // Single auditorium view large screen
  &_isef {
    top: calc(52px + 2rem);
  }
  &_auditorium {
    left: calc(100vw/2 - 400px - 100px - 7rem) !important;
    // Re-adjust for smaller screen
    @media only screen and (max-width: 1200px) {
      left: calc(100vw/2 - 400px - 100px - 3rem) !important;
    }
  }

  .dropdown-wrapper {
    &:hover {
      cursor: pointer;
    }
  }
  .meta-views {
    i {
      cursor: default;
    }
  }
  .milieu-icon, i  {
    cursor: cursor;
    background-color: rgb(255, 255, 255);
    border-radius: 20px;
    padding-top: 10px;
    margin-bottom: 10px;
    width: 30px;
    height: 30px;
    text-align: center;
    &:hover {
      color: $primary;
    }
  }

  .facebook  {
    background-color: #3b5998;
    border-radius: 20px;
    margin-bottom: 0px;
    text-align: center;
    color: white;
    &:hover {
      color: white;
    }
  }

  .twitter  {
    background-color: #00acee;
    border-radius: 20px;
    text-align: center;
    color: white;
    &:hover {
      color: white;
    }
  }

  .pinterest  {
    background-color: transparent;
    border-radius: 20px;
    padding-top: 0px !important;
    font-size: 27px !important;
    margin-top: 10px;
    margin-bottom: 15px !important;
    text-align: center;
    &:hover {
      color: $primary;
    }
    @media(max-width: 1023px) {
      margin-top: 0;
      margin-bottom: 5px !important;
    }
  }

  .google {
    background-color: transparent;
    padding-top: 0px !important;
  }
    .linkedin  {
    background-color: #0e76a8;
    border-radius: 20px;
    text-align: center;
    color: white;
    &:hover {
      color: white;
    }
  }
  .engagement-container {
    display: flex;
    flex-wrap: wrap;
    padding: 1rem;
    font-size: 13px;
    margin-top: 2.5rem;
    .engagement {
      margin-bottom: 15px;
      i {
        margin-right: 10px;
        @media(max-width: 1023px) {
          margin-right: 0px;
        }
      }
      .fa, .bookmarked {
        color: $primary;
      }
      div{
        display: flex;
        span, .dropdown-count {
          font-size: .75rem;
          margin-top: 8px;
        }
      }
    }
    .milieu {
      border-top: 1px solid #AAAAAA;
      display: inline-block;
      position: relative;
      .milieu-icon {
        display: block;
        padding-top: 5px;
      }
      i {
        padding: 0;
        margin: 0;
        height: auto;
        width: auto;
      }
      .milieu-text {
        display: block;
        padding: 20px 0;
      }
    }
  }
}
.is-IE {
  left: calc(100vw/2 - 400px - 150px - 16px);
}
.is-fixed {
  position: fixed;
  left: 0;
  right: 0;
  margin-top: 0 !important;
  box-shadow: 0px 2px 10px 0px rgba(15, 15, 15, 0.1);
}
.fix-to-bottom {
  bottom: 0; // account for the nav
  transition: all .5s ease;
}
.fix-to-top {
  top: 52px;
  &.has-publish-toolbar {
    top: 92px;
  }
}
.is-invisible {
  opacity: 0;
  transition: 0.5s ease-in;
}
@media (max-width: 1140px){
  .engagement-wrapper {
    top: calc(52px + 2rem);
    left: calc(100vw/2 - 400px - 100px - 0.5rem);
  }
}
@include touch {
  .engagement-wrapper {
    width: 100%;
    position: relative;
    margin: 0 auto;
    text-align: center;
    z-index: 9;
    margin: 0 auto;
    top: 0;
    left: 0;
    height: 50px;

    @media only screen
    and (max-height: 430px)
    and (orientation: landscape) {
      height: 30px !important;
    }

    i {
      padding-top: 9px;
    }
    .engagement-container {
      width: 100%;
      display: flex;
      flex-wrap: nowrap;
      justify-content: center;
      padding: 1rem;
      height: 50px;
      background-color: rgba(242, 242, 242, 0.952);
      margin-top: .8rem;
      @include mobile {
        padding: 1rem .25rem;
      }

      @media only screen
      and (max-height: 430px)
      and (orientation: landscape) {
        height: 26px !important;
      }

      .engagement {
        display: flex;
        justify-content: space-evenly;
        align-items: center;
        margin-bottom: 0px;
        padding-bottom: 0px;
        margin-right: 10px;
        .dropdown-wrapper, .meta-views {
          div {
            margin-right: 0;
          }
        }
        div {
          margin-right: 10px;
          white-space: nowrap;
          @media(max-width: 1023px) {
            div {
              margin-right: 0px;
            }
          }
          @include mini-mobile {
            margin-right: 5px;
            span, .dropdown-count {
              font-size: .6rem;
              margin-top: 8px;
            }
          }
        }
        i {
          margin-bottom: 0;
          margin-right: 2px;
        }
      }
      .milieu { // Another term for "social" -- beating the ad blockers class name search.
        border-left: 1px solid #AAAAAA;
        border-top: none;
        display: flex;
        position: relative;
        justify-content: space-evenly;
        align-items: center;
        .milieu-icon {
          margin-left: 5px;
          margin-bottom: 0;
        }
        .milieu-text {
          padding: 0 10px 0 20px;
        }
      }
    }
  }
}
.dropdown-count {
  @include touch {
    padding-right: 0;
  }
}

.copy {
  background-color: rgb(255, 255, 255) !important;
  color: black !important;
}
.print {
  background-color: rgb(255, 255, 255) !important;
  color: black !important;
}

#pinterest-red {
  display: inline-block;
  font-size: 1.935rem;
  max-height: 30px;
  max-width: 30px;
  color: #c8232c !important;
  padding: 0 !important;
}

#reddit-orange {
  display: inline-block;
  font-size: 1.935rem;
  max-height: 30px;
  max-width: 30px;
  color: #FF5700 !important;
  padding: 0 !important;
}

.socialshare {
  @media (max-width: 1023px) {
  visibility: hidden;
  text-align: center;
  display: inline-block;
  position: relative;
  height: 100%;
  }
}

.socialContainer{
  @media (max-width: 1023px) {
  position: absolute;
  bottom: 35px;
  right:5px;
  width: 70%;
  -webkit-transition: all 0.4s ease-in-out;
  transition: all 0.4s ease-in-out;
  transition-timing-function: cubic-bezier(0, 0, 1, 1);
  background-color: none;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 10px !important;
  padding-right: 5px !important;
  margin: 0;
  border-radius: 23px;
  visibility: hidden;
  .socialshare {
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
  }
  .shareDesktop {
    display: none !important;
  }
  }
}

.socialContainerBottom{
  @media (max-width: 1023px) {
    height: auto;
    bottom: -300px;
  }
}

.bottomPrint{
  @media (max-width: 1023px) {
    height: auto;
    bottom: -342px;
  }
}

.socialContainerAnimated {
  padding-bottom: 5px;
  padding-top:5px;
  padding-right: 3.75px;
  visibility: visible;
  @media (max-width: 1023px) {
    background-color: rgba(242, 242, 242, 0.90);
  }
}

.socialicons {
  visibility: visible;
  transition: visibility 0s, opacity 0.5s linear;
}

.socialContainer .copyAnimation {
  -webkit-transition-delay: 0.005s;
  transition-delay: 0.005s;
}

.socialContainer .printAnimation {
  -webkit-transition-delay: 0.05s;
  transition-delay: 0.05s;
}

.socialContainer .classroomAnimation {
  -webkit-transition-delay: 0.1s;
  transition-delay: 0.1s;
}

.socialContainer .linkedinAnimation {
  -webkit-transition-delay: 0.15s;
  transition-delay: 0.15s;
}

.socialContainer .pinterestAnimation {
  -webkit-transition-delay: 0.20s;
  transition-delay: 0.20s;
}

.socialContainer .facebookAnimation {
  -webkit-transition-delay: 0.25s;
  transition-delay: 0.25s;
}

.socialContainer .twitterAnimation {
  -webkit-transition-delay: 0.30s;
  transition-delay: 0.30s;
}

.socialContainerBottom .copyAnimation, .bottomPrint .copyAnimation {
  -webkit-transition-delay: 0.30s;
  transition-delay: 0.30s;
}

.socialContainerBottom .printAnimation, .bottomPrint .printAnimation {
  -webkit-transition-delay: 0.25s;
  transition-delay: 0.25s;
}

.socialContainerBottom .classroomAnimation, .bottomPrint .classroomAnimation {
  -webkit-transition-delay: 0.20s;
  transition-delay: 0.20s;
}

.socialContainerBottom .linkedinAnimation, .bottomPrint .linkedinAnimation {
  -webkit-transition-delay: 0.15s;
  transition-delay: 0.15s;
}

.socialContainerBottom .pinterestAnimation, .bottomPrint .pinterestAnimation {
  -webkit-transition-delay: 0.1s;
  transition-delay: 0.1s;
}

.socialContainerBottom .facebookAnimation, .bottomPrint .facebookAnimation {
  -webkit-transition-delay: 0.05s;
  transition-delay: 0.05s;
}

.socialContainerBottom .twitterAnimation, .bottomPrint .twitterAnimation {
  -webkit-transition-delay: 0.005s;
  transition-delay: 0.005s;
}

.dropdownOpened .copyAnimation {
  -webkit-transition-delay: 0.30s;
  transition-delay: 0.30s;
}

.dropdownOpened .printAnimation {
  -webkit-transition-delay: 0.25s;
  transition-delay: 0.25s;
}

.dropdownOpened .classroomAnimation {
  -webkit-transition-delay: 0.20s;
  transition-delay: 0.20s;
}

.dropdownOpened .linkedinAnimation {
  -webkit-transition-delay: 0.1s;
  transition-delay: 0.1s;
}

.dropdownOpened .pinterestAnimation {
  -webkit-transition-delay: 0.15s;
  transition-delay: 0.15s;
}

.dropdownOpened .facebookAnimation {
  -webkit-transition-delay: 0.05s;
  transition-delay: 0.05s;
}

.dropdownOpened .twitterAnimation {
  -webkit-transition-delay: 0.005s;
  transition-delay: 0.005s;
}

.socialContainerBottom.dropdownOpened .copyAnimation, .bottomPrint.dropdownOpened .copyAnimation {
  -webkit-transition-delay: 0.005s;
  transition-delay: 0.005s;
}

.socialContainerBottom.dropdownOpened .printAnimation, .bottomPrint.dropdownOpened .printAnimation {
  -webkit-transition-delay: 0.05s;
  transition-delay: 0.05s;
}

.socialContainerBottom.dropdownOpened .classroomAnimation, .bottomPrint.dropdownOpened .classroomAnimation {
  -webkit-transition-delay: 0.15s;
  transition-delay: 0.15s;
}

.socialContainerBottom.dropdownOpened .linkedinAnimation, .bottomPrint.dropdownOpened .linkedinAnimation {
  -webkit-transition-delay: 0.1s;
  transition-delay: 0.1s;
}

.socialContainerBottom.dropdownOpened .pinterestAnimation, .bottomPrint.dropdownOpened .pinterestAnimation {
  -webkit-transition-delay: 0.20s;
  transition-delay: 0.20s;
}

.socialContainerBottom.dropdownOpened .facebookAnimation, .bottomPrint.dropdownOpened .facebookAnimation {
  -webkit-transition-delay: 0.25s;
  transition-delay: 0.25s;
}

.socialContainerBottom.dropdownOpened .twitterAnimation, .bottomPrint.dropdownOpened .twitterAnimation {
  -webkit-transition-delay: 0.30s;
  transition-delay: 0.30s;
}

.main-button {
  display: none;
  @media (max-width: 1023px) {
    display: block;
    width: 4rem;
    padding: 0;
    background: 0;
    margin: 0;
    border: 0;
    height: 30.15px;
    margin-left: 15px;
    img {
      border-radius: 5%;
      height: 100%;
      display: inline-block;
    }
  }
}

.main-button:hover {
  cursor: pointer
}

  .view-booth {
    display: block;
    position: absolute;
    top: 2%;
    cursor: pointer;
    z-index: 20;
    left: 1%;
    @media (max-width: 1023px) {
      top: revert;
    }
    @include tablet {
      left: 3%;
    }
    @include mobile {
      left: 5%;
    }
    .button {
      padding: 0.25rem 0.5rem;
      font-size: 0.75rem;
      text-transform: uppercase;
      right: 1rem;
      bottom: 50%;
      background: $primary;
      cursor: pointer;
    }
  }

  .view-board {
    display: block;
    position: absolute;
    left: 5%;
    top: -7%;
    cursor: pointer;
    z-index: 20;
    .button {
      padding: 0.25rem 0.5rem;
      font-size: 0.75rem;
      right: 1rem;
      bottom: 50%;
      background: $primary;
      cursor: pointer;
      text-transform: uppercase;
    }
  }

  @media (max-width: 1023px) {
  .view-board{
    top: 13%;
    left: 2%;
    }
  }

  @media (max-width: 414px) {
    .button {
      font-size: 0.55rem !important;
    }
  }
  .awards-container {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 1rem;
    @media(max-width: 1023px) {
      margin-bottom: 0rem;
      width: 16%;
      height: 100%;
    }
    .award{
      width: 33.3%;
      height: 33.3%;
      flex-grow: 0.5;
      @media(max-width: 1023px) {
        flex-grow: 0;
        height: 200%;
      }
      .img-awards {
        display: block;
        height: 100%;
      }
    }
    .hide-award {
      display: none;
      width: 0;
      height: 0;
    }
  }
</style>
